
export class InvoiceRefundableStatusResponse {
    InvoiceCredit : number;
    InvoiceTotal : number;
    IsSettled : boolean;
    RefundMonetary : number;
    RefundCredit : number;
    TryToRefund : number;
    IsRefundable: boolean;
    IsFullyRefundable: boolean;
    IsPartiallyRefundable : boolean;
    Message : string;
    IsVoided: boolean;
    TotalRefundable: number;
}

